import DCalendar from './src';

DCalendar.install = Vue => {
  Vue.component('DCalendar', DCalendar);
};

export default DCalendar;
